<template>
    <Head title="Login" />
    <form class="mt-1 w-full max-w-lg" @submit.prevent="forgot_token">
      <div class="py-12 px-10">
        <h1 class="text-3xl">Recuperar senha</h1>
        <div class="mt-6">
          Informe o código que enviamos para o seu e-mail.
        </div>
        <mask-input mask="####" v-model="form.token" :error="form.errors.token" class="mt-6" label="Código" type="tel" autofocus autocapitalize="off" />
        <loading-button :loading="form.processing" class="btn-primary w-full mt-6 justify-center" type="submit">Verificar código</loading-button>
        <div class="w-full pt-6 flex justify-center">
          <Link class="text-primary underline text-right" href="/login">
            Fazer Login
          </Link>
        </div>
      </div>
    </form>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import MaskInput from '@/Shared/Fields/MaskInput'
  import PasswordInput from '@/Shared/Fields/PasswordInput'
  import LoadingButton from '@/Shared/Components/LoadingButton'
  import Layout from '@/Pages/Auth/Professional/Layout'
  
  export default {
    props: {
      email: String,
    },
    layout: Layout,
    components: {
      Head,
      Link,
      LoadingButton,
      MaskInput,
      PasswordInput,
    },
    data() {
      return {
        form: this.$inertia.form({
          email: this.email,
          token: ''
        }),
      }
    },
    methods: {
      forgot_token() {
        this.form.post('/forgot-password-token')
      },
    },
  }
  </script>
  